import { BlockStack, Card, Text, TextField } from "@shopify/polaris";

import type { PurchaseOrderHeader } from "../../utils/purchaseOrderEdits";

import { t } from "../../lib/i18n";

type Props = {
  header: PurchaseOrderHeader;
  onChange: (patch: Partial<PurchaseOrderHeader>) => void;
  stockyTemplateApplied?: boolean;
};

/**
 * 右レールの「注文書の詳細」。純正用語に合わせた発行日/参照番号/希望納品日/
 * サプライヤーへのメモ。すべてこの注文書限り（永続しない）。
 * ※内部の型キー(poNumber/note)は不変。出力PDF/CSVは「発注書」表記のまま。
 */
export function PoDetailsCard({
  header,
  onChange,
  stockyTemplateApplied = false,
}: Props) {
  return (
    <Card>
      <BlockStack gap="300">
        <Text as="h3" variant="headingSm">
          {t("注文書の詳細")}
        </Text>
        <TextField
          label={t("発行日")}
          type="date"
          value={header.issueDate}
          onChange={(v) => onChange({ issueDate: v })}
          autoComplete="off"
        />
        <TextField
          label={t("参照番号")}
          value={header.poNumber}
          onChange={(v) => onChange({ poNumber: v })}
          placeholder={t("例: PO-2026-001")}
          autoComplete="off"
        />
        <TextField
          label={t("希望納品日")}
          type="date"
          value={header.desiredDeliveryDate}
          onChange={(v) => onChange({ desiredDeliveryDate: v })}
          autoComplete="off"
        />
        <TextField
          label={t("サプライヤーへのメモ")}
          multiline={2}
          value={header.note}
          onChange={(v) => onChange({ note: v })}
          maxLength={2000}
          showCharacterCount
          helpText={
            stockyTemplateApplied
              ? t(
                  "Stockyで確認して転記した発注書用メモを初期入力しました。編集した内容がPDF・CSV・メール・確定済み発注書に反映されます。",
                )
              : undefined
          }
          autoComplete="off"
        />
      </BlockStack>
    </Card>
  );
}
